import {
  Box,
  Slide,
  Theme,
  Tooltip,
  TooltipProps,
  Typography,
  makeStyles,
  createStyles,
  ButtonBase
} from '@material-ui/core';
import React from 'react';
import theme from './theme';

const useStyles = makeStyles(({ spacing, breakpoints }: Theme) =>
  createStyles({
    root: {
      width: '100%',

      [breakpoints.only('xl')]: {
        height: '11vw'
      },
      [breakpoints.only('lg')]: {
        height: '14vw'
      },
      [breakpoints.only('md')]: {
        height: '22vw'
      },
      [breakpoints.only('sm')]: {
        height: '27vw'
      },
      [breakpoints.only('xs')]: {
        height: '70vw'
      },
      '&:hover': {
        boxShadow:
          'rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset'
      }
    },
    media: {
      padding: spacing(0),
      [breakpoints.down('sm')]: { marginBottom: spacing(3) }
    },
    verticalPadding: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1)
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    title: {
      fontWeight: 500
    },
    action: {
      position: 'absolute',
      bottom: spacing(1),
      left: spacing(1)
    },
    img: {
      width: '45%',
      height: 'auto'
    },
    tooltip: {
      padding: spacing(1.5),
      maxWidth: 270,
      fontSize: '1rem',
      whiteSpace: 'pre-line'
    },
    dangerTape: {
      transform: 'translateX(-5%) rotate(-45deg)',
      transformOrigin: '0% 50%',
      backgroundColor: 'rgba(255,255,0,0.9)',
      textAlign: 'center'
    }
  })
);

export interface ICustomCardProps {
  onStart: () => void;
  label: string;
  imageUri: string;
  tooltip: string;
  tooltipPosition?: TooltipProps['placement'];
  sealed?: boolean;
}
const CustomCard: React.FunctionComponent<ICustomCardProps> = ({
  onStart,
  label,
  imageUri,
  tooltip,
  tooltipPosition,
  sealed
}) => {
  const classes = useStyles(theme);
  const [start, setStart] = React.useState(false);

  React.useEffect(() => {
    if (!start) {
      setStart(true);
    }
  }, [start]);

  return (
    <Tooltip
      title={<Box>{tooltip}</Box>}
      classes={{ tooltip: classes.tooltip }}
      placement={tooltipPosition}
      arrow
    >
      <Slide timeout={900} in={start} direction="up">
        <Box display="flex" justifyContent="center" alignItems="center" m={0.5}>
          <ButtonBase className={classes.root}>
            <Box
              onClick={onStart}
              bgcolor="white"
              boxShadow={2}
              overflow="hidden"
              borderRadius="2px"
              height="1"
              width="1"
            >
              <Box height="0.15" overflow="hidden" paddingTop={1} paddingX={1}>
                <Typography align="center" variant="h6">
                  {label}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="0.8"
              >
                <img src={imageUri} className={classes.img} alt={label} />
              </Box>
              {sealed && (
                <Box
                  width="155%"
                  padding={1}
                  className={classes.dangerTape}
                  zIndex={10}
                >
                  <Typography style={{ fontWeight: 500 }} variant="h5">
                    COMING SOON
                  </Typography>
                </Box>
              )}
            </Box>
          </ButtonBase>
        </Box>
      </Slide>
    </Tooltip>
  );
};

export default CustomCard;
